import type { InferDecisionMakersResult } from './api';

/**
 * DMs the model itself ranked highly and cleared meets_threshold -- mirrors Seun's DMI logic for
 * Scaled Outreach, generalized from his single-pick case to our uncapped topRecommendations.
 */
export function eligibleDms(response: InferDecisionMakersResult) {
	const byPoliticianId = new Map(response.recommendations.map((r) => [r.politicianId, r]));

	return response.topRecommendations
		.map((id) => byPoliticianId.get(String(id)))
		.filter((r): r is NonNullable<typeof r> => Boolean(r?.meetsThreshold))
		.map((r) => ({
			politician_id: r.politicianId,
			confidence: r.confidence,
			meets_threshold: r.meetsThreshold,
			would_assign: r.wouldAssign,
		}));
}
